<template>
  <sModal
    class="flex"
    :closable="false"
    :content-style="'background: var(--color-main-green);padding: 0;'"
    :data-qa="`${dataQa}-modal`"
    :footer-hide="true"
    fullscreen
    :mask-closable="false"
    :value="open">
    <sButton
      slot="activator"
      class="my-auto"
      :data-qa="`${dataQa}-btn-chat`"
      :disabled="disabled"
      icon="chat-launch"
      small
      type="text"
      @click="$emit('update:open', true)"/>
    <div
      class="height-100 px-10">
      <div
        class="exit-btn">
        <sButton
          data-qa="btn-close-dialog"
          icon="cross"
          type="text"
          @click="$emit('update:open', false)"/>
      </div>
      <div
        v-if="open"
        class="height-100">
        <v-tabs
          background-color="var(--color-main-green)"
          class="row-rabs pb-5 pl-2"
          :class="{'hide-slider': !tabs || tabs.length < 2}"
          color="var(--black-color)"
          data-qa="history-tabs"
          :value="currentTab"
          @change="value => $emit('update:currentTab', value)">
          <div class="row flex flex-start">
            <v-tab
              v-for="tab in tabs"
              :key="tab.value"
              class="h4-headline black--text tab-name"
              :data-qa="`history-tabs-${tab.value}`"
              :disabled="!tab.showDialog">
              <sBadge
                :class="!tab.badge.dot && tab.count ? 'mr-3' : ''"
                :color="tab.badge.dot ? 'red' : 'transparent'"
                :content="tab.count"
                data-qa="history-dialog-badge"
                :dot="tab.badge.dot"
                :offset-x="tab.badge.dot ? -3 : 5"
                :offset-y="tab.badge.dot ? 4 : 10"
                overlap
                :text-color="tab.badge.dot ? 'var(--white-color)' : 'var(--black-color)'"
                :value="tab.count">
                <sIcon
                  v-if="tab.icon"
                  size="12"
                  :type="tab.icon"/>
                {{ tab.name }}
              </sBadge>
            </v-tab>
          </div>
        </v-tabs>

        <div class="row-chats">
          <dialog-inner-chat
            v-if="tabs[currentTab] && tabs[currentTab].value === 'innerChat'"
            :key="`currentTab.value-${itemId}`"
            data-qa="dialog-inner-chat"
            :show="open"
            :tender="tender"
            :value="tabs[currentTab].valueItems"
            @loadPage="$emit('loadPage')"/>
          <div
            v-else-if="!tabs[currentTab] || !tabs[currentTab].items || !tabs[currentTab].items.length"
            class="width-100 height-100 flex"
            style="background: var(--v-main__light_green-base);border-radius: 6px;">
            <EmptyTab
              class="m-auto"
              data-qa="empty-tab"/>
          </div>
          <component
            v-else
            :is="historyComponents[tabs[currentTab].value]"
            :data-qa="`history-component-${currentTab}`"
            :item-id.sync="itemIdSync"
            :items="tabs[currentTab].items"
            :show="open"
            :spr="tabs[currentTab].spr"
            :tender="tender"
            @update:items="updateItems"/>
        </div>
      </div>
    </div>
  </sModal>
</template>
<script>
import EmptyTab from 'components/common/elements/EmptyTab.vue'
import DialogHistory from 'components/common/blocks/history/DialogHistory.vue'
import DialogComments from 'components/common/blocks/history/DialogComments.vue'
import DialogAgreement from 'components/common/blocks/history/DialogAgreement.vue'
import DialogQuestions from 'components/common/blocks/history/DialogQuestions.vue'
import DialogInnerChat from 'components/common/blocks/inner-chat/DialogInnerChat.vue'

/**
 * Диалог отображения чатов, вопросов и остальной нужной инфы в полноекранном режиме
 */
export default {
  name: 'historyDialog',
  data() {
    return {
      modal: false,
      historyComponents: {
        innerChat: 'DialogInnerChat',
        comments: 'DialogComments',
        questions: 'DialogQuestions',
        history: 'DialogHistory',
        agreement: 'DialogAgreement'
      }
    }
  },
  methods: {
    updateItems(val) {
      const tabs = this.$_.cloneDeep(this.tabs)
      tabs[this.currentTab].items = val
      const value = {
        prop: tabs[this.currentTab].value,
        val
      }
      this.$emit('update-items', value)
    }
  },
  computed: {
    itemIdSync: {
      get: function () {
        return this.itemId
      },
      set: function (newValue) {
        this.$emit('update:itemId', newValue)
      }
    }
  },
  props: {
    /**
     * все табы
     */
    tabs: {
      type: Array
    },
    /**
     * Данные тендера
     */
    tender: {
      type: Object
    },
    /**
     * номер вкладки по порядку
     */
    currentTab: {
      type: Number
    },
    itemId: {
      type: [String, Number]
    },
    open: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    dataQa: {
      type: String,
      default: 'history-dialog'
    }
  },
  components: {
    EmptyTab,
    DialogHistory,
    DialogComments,
    DialogAgreement,
    DialogQuestions,
    DialogInnerChat
  }
}
</script>
<style scoped>
.row-rabs {
  margin-bottom: 10px;
  height: 48px;
  padding-bottom: 10px;
}
.row-chats {
  height: calc(100% - 68px);
}
.exit-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 210;
}
</style>
